class RestApi {
  constructor(client, url, defaultParams = {}) {
    this.url = url
    this.client = client
    this.defaultParams = defaultParams
  }

  search(params, nameSearchField) {
    return this.client
      .get(`${this.url}?filters[${nameSearchField}]=${params.search}`, { params })
      .then((response) => response.data)
  }

  index(params) {
    if (params?.search === '') {
      params.search = undefined
    }
    return this.client.get(this.url, { params, ...this.defaultParams }).then((response) => response.data)
  }

  show(id, params = {}) {
    return this.client
      .get(`${this.url}/${id}`, {
        params: { ...params, ...this.defaultParams },
      })
      .then((response) => response.data)
  }

  store(data) {
    return this.client.post(this.url, data).then((response) => ({ ...response.data, status: response.status }))
  }

  update(id, data) {
    return this.client
      .put(`${this.url}/${id}`, data)
      .then((response) => ({ ...response.data, status: response.status }))
  }

  updateWithHash(id, params) {
    return this.client.put(`${this.url}/hash/${id}`, params).then((response) => response.data)
  }

  partialUpdate(id, params) {
    return this.client.patch(`${this.url}/${id}`, params).then((response) => response.data)
  }

  delete(id) {
    return this.client.delete(`${this.url}/${id}`).then((response) => response)
  }
}

export default RestApi
